import { GlobalSettings } from '../global/GlobalSettings'

// Image paths for dev vs production
const BuildPath = ():string => {

    let basePath = "/toolkit-react/build";

    if (process.env.NODE_ENV === "development"){
        basePath = "";
    }

    return basePath;
}


const CmsPath = ():string => {

    let basePath = "";

    if (process.env.NODE_ENV === "development"){
        basePath = GlobalSettings.CmsPath
    }

    return basePath;
}

const flagBuilder = (countryCode:string) => {



    if (process.env.NODE_ENV === "development"){
        return `images/translations/Flags/${countryCode?.toLowerCase() ?? "flagNotFound"}.svg`
    }

    return `/toolkit-react/build/images/translations/Flags/${countryCode?.toLowerCase() ?? "flagNotFound"}.svg`
}

const environmentFromUrl = (url?: string): string => {
    try {
        const locationUrl = url || window.location.href;
        const { hostname, port } = new URL(locationUrl);
        const parts = hostname.split('.');
        
        if (parts.length <= 2) {
            return port 
            ? `${hostname}:${port}` : hostname;
        }

        let mainDomain = parts.slice(-2).join('.');

        if (parts.includes('tab-feature')) {
            mainDomain = parts.slice(-3).join('.');
        }
       

        return port ? `${mainDomain}:${port}` : mainDomain;
    } catch (e) {
        return '';
    }
};

function getFeatureBranchName(url = window.location.href) {
  const hostname = new URL(url).hostname;
  return hostname.split('.')[1];
}

function getFlagStyle (flagPath: string){
    return {
        backgroundImage: `url(${flagPath}), url(${BuildPath()}/images/translations/Flags/flagNotFound.svg)`, 
        backgroundRepeat: 'no-repeat, no-repeat', 
        backgroundSize: 'cover, cover', 
        backgroundPosition: 'center, center'
    }
}

export { BuildPath, CmsPath, flagBuilder, getFlagStyle, environmentFromUrl, getFeatureBranchName}